<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'STATIC_CONTENT_TEMPLATES' }
  ]"
></breadcrumbs>

<page-header title="STATIC_CONTENT_TEMPLATES"></page-header>

<app-table
  [isLoading]="isLoading"
  [totalItems]="state.get('total')"
  [totalResults]="state.get('results')"
  [itemsPerPage]="getQueryParam('page_size')"
  [rows]="state.get('data')"
  [currentPage]="getQueryParam('page')"
  (onPageChange)="handlePageChange($event)"
  (onPageSizeChange)="handlePageSizeChange($event)"
  (onSort)="handleSort($event)"
  [sort]="getQueryParam('sort')"
  [orderBy]="getQueryParam('order_by')"
  [columns]="columns"
>
  <ng-template #addonRight>
    <form class="ml-auto">
      <input
        class="input is-small"
        type="text"
        (input)="handleFilterChange($event)"
        [value]="getQueryParam('keyword')"
        name="keyword"
        [placeholder]="'SEARCH' | translate"
        [translationEditableModalDirective]="['SEARCH']"
      />
    </form>
  </ng-template>

  <ng-template let-row="row" #titleColumn>
    <span [translationEditableDirective]="row.get('translationKey')">{{
      row.get('translationKey') | translate
    }}</span>
  </ng-template>
  <ng-template let-row="row" #actionsColumn>
    <div class="buttons m-0">
      <a
        [routerLink]="[row.get('name'), 'update']"
        class="button is-small ml-auto"
        translationEditableDirective="UPDATE"
        >{{ 'UPDATE' | translate }}</a
      >
    </div>
  </ng-template>
</app-table>
